module.exports = __webpack_public_path__ + "img/create_team.4bf69025.svg";